import styled, { css } from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, rydeColors, ScreenDepth } from "@ryde/theme";

export const MainStyled = styled.main.attrs<IStyledAttributes>({
  "data-e2e": "main-container",
})<{ $noScrollMode?: boolean }>`
  grid-area: main;
  position: relative;
  z-index: ${ScreenDepth.MAIN_CONTAINER};
  background-color: ${rydeColors.smoke};
  display: flex;
  flex-direction: column;
  min-height: 0;
  ${({ $noScrollMode }) =>
    $noScrollMode
      ? css`
          overflow: hidden;
        `
      : css`
          overflow: auto;
        `};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-bottom: 30px;

    &:has(.chat-bot-container) {
      padding-bottom: 0px;
    }
  }
`;

export const PageLayoutGridStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "page-layout-grid",
})`
  width: 100vw;
  height: 100vh;
  display: grid;
  gap: 0px 0px;
  grid-template-columns: 62px 1fr;
  /*
     minmax(0, ...) rather than a bare 1fr, and it is load-bearing. A bare 1fr means
     minmax(auto, 1fr), so the row can never be shorter than its tallest item min-content
     height — and the sidebar is a flex column of fixed-height buttons that does not shrink. Once
     the nav outgrows a short window the row, and main stretched into it, grow past 100vh; the
     part below the fold is then unreachable, because body has overflow-y: hidden and there is no
     document scroll to recover it. main already carries min-height: 0 for its own half of this;
     the track needs the same cap or one item can still push it.
  */
  grid-template-rows: minmax(0, 1fr);
  grid-template-areas: "sidenav main";

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    background-color: blue;
    grid-template-columns: 1fr;
    grid-template-rows: 56px minmax(0, 1fr);
    grid-template-areas:
      "mobile_header"
      "main";
  }
`;
